/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthAccessdeniedRouteImport } from './routes/_auth/accessdenied'
import { Route as AppManagementRouteImport } from './routes/_app/management'
import { Route as AppMailRouteImport } from './routes/_app/mail'
import { Route as AppLeadsRouteImport } from './routes/_app/leads'
import { Route as AppEvaluationRouteImport } from './routes/_app/evaluation'
import { Route as AppCommunicationRouteImport } from './routes/_app/communication'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppBucketLeadsRouteImport } from './routes/_app/bucketLeads'
import { Route as AppAccountingRouteImport } from './routes/_app/accounting'
import { Route as AuthRegisterIndexRouteImport } from './routes/_auth/register/index'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index'
import { Route as AppManagementIndexRouteImport } from './routes/_app/management/index'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AuthResetSecretIndexRouteImport } from './routes/_auth/reset/secret/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/_auth/reset/password/index'
import { Route as AuthRequestPasswordIndexRouteImport } from './routes/_auth/request/password/index'
import { Route as AppManagementUsersIndexRouteImport } from './routes/_app/management/users/index'
import { Route as AppManagementPartnersIndexRouteImport } from './routes/_app/management/partners/index'
import { Route as AppManagementHeader_footerIndexRouteImport } from './routes/_app/management/header_footer/index'
import { Route as AppManagementDivisionsIndexRouteImport } from './routes/_app/management/divisions/index'
import { Route as AppManagementDivisionIndexRouteImport } from './routes/_app/management/division/index'
import { Route as AppManagementDistributionIndexRouteImport } from './routes/_app/management/distribution/index'
import { Route as AppManagementCorporationsIndexRouteImport } from './routes/_app/management/corporations/index'
import { Route as AppManagementAdvisersIndexRouteImport } from './routes/_app/management/advisers/index'
import { Route as AppManagementTemplatesGeneralRouteImport } from './routes/_app/management/templates/general'
import { Route as AppManagementTemplatesDivisionsRouteImport } from './routes/_app/management/templates/divisions'
import { Route as AppManagementTemplatesDivisionRouteImport } from './routes/_app/management/templates/division'
import { Route as AppManagementBucketConfigurationsRouteImport } from './routes/_app/management/bucket/configurations'
import { Route as AppLeadsDetailsLeadIdRouteImport } from './routes/_app/leads_/details/$leadId'
import { Route as AppLeadsDetailsLeadIdIndexRouteImport } from './routes/_app/leads_/details/$leadId/index'
import { Route as AppManagementTemplatesGeneralTemplateIdRouteImport } from './routes/_app/management/templates/general/$templateId'
import { Route as AppManagementTemplatesDivisionsTemplateIdRouteImport } from './routes/_app/management/templates/divisions/$templateId'
import { Route as AppManagementTemplatesDivisionTemplateIdRouteImport } from './routes/_app/management/templates/division/$templateId'
import { Route as AppManagementBucketConfigurationsBucketRouteImport } from './routes/_app/management/bucket/configurations/$bucket'
import { Route as AppLeadsDetailsLeadIdOfferManagementRouteImport } from './routes/_app/leads_/details/$leadId/offer-management'
import { Route as AppLeadsDetailsLeadIdIncomeProtectionRouteImport } from './routes/_app/leads_/details/$leadId/income-protection'
import { Route as AppLeadsDetailsLeadIdHistoryRouteImport } from './routes/_app/leads_/details/$leadId/history'
import { Route as AppLeadsDetailsLeadIdDocumentCenterRouteImport } from './routes/_app/leads_/details/$leadId/document-center'
import { Route as AppLeadsDetailsLeadIdCustomerDataRouteImport } from './routes/_app/leads_/details/$leadId/customer-data'
import { Route as AppLeadsDetailsLeadIdBankRequestRouteImport } from './routes/_app/leads_/details/$leadId/bank-request'
import { Route as AppLeadsDetailsLeadIdHistoryIndexRouteImport } from './routes/_app/leads_/details/$leadId/history/index'
import { Route as AppLeadsDetailsLeadIdCustomerDataIndexRouteImport } from './routes/_app/leads_/details/$leadId/customer-data/index'
import { Route as AppLeadsDetailsLeadIdBankRequestIndexRouteImport } from './routes/_app/leads_/details/$leadId/bank-request/index'
import { Route as AppLeadsDetailsLeadIdHistoryCategoryIdRouteImport } from './routes/_app/leads_/details/$leadId/history/$categoryId'
import { Route as AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteImport } from './routes/_app/leads_/details/$leadId/customer-data/$customerTab'
import { Route as AppLeadsDetailsLeadIdBankRequestRequestHistoryRouteImport } from './routes/_app/leads_/details/$leadId/bank-request/request-history'
import { Route as AppLeadsDetailsLeadIdBankRequestNewRequestRouteImport } from './routes/_app/leads_/details/$leadId/bank-request/new-request'
import { Route as AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRouteImport } from './routes/_app/leads_/details/$leadId/customer-data/$customerTab/$realEstateId/$step'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthAccessdeniedRoute = AuthAccessdeniedRouteImport.update({
  id: '/accessdenied',
  path: '/accessdenied',
  getParentRoute: () => AuthRoute,
} as any)
const AppManagementRoute = AppManagementRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => AppRoute,
} as any)
const AppMailRoute = AppMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsRoute = AppLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/leads.lazy').then((d) => d.Route))
const AppEvaluationRoute = AppEvaluationRouteImport.update({
  id: '/evaluation',
  path: '/evaluation',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunicationRoute = AppCommunicationRouteImport.update({
  id: '/communication',
  path: '/communication',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppBucketLeadsRoute = AppBucketLeadsRouteImport.update({
  id: '/bucketLeads',
  path: '/bucketLeads',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/bucketLeads.lazy').then((d) => d.Route),
)
const AppAccountingRoute = AppAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AppRoute,
} as any)
const AuthRegisterIndexRoute = AuthRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any)
const AppManagementIndexRoute = AppManagementIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppManagementRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AuthResetSecretIndexRoute = AuthResetSecretIndexRouteImport.update({
  id: '/reset/secret/',
  path: '/reset/secret/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/reset/password/',
  path: '/reset/password/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRequestPasswordIndexRoute =
  AuthRequestPasswordIndexRouteImport.update({
    id: '/request/password/',
    path: '/request/password/',
    getParentRoute: () => AuthRoute,
  } as any)
const AppManagementUsersIndexRoute = AppManagementUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppManagementRoute,
} as any).lazy(() =>
  import('./routes/_app/management/users/index.lazy').then((d) => d.Route),
)
const AppManagementPartnersIndexRoute =
  AppManagementPartnersIndexRouteImport.update({
    id: '/partners/',
    path: '/partners/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/partners/index.lazy').then((d) => d.Route),
  )
const AppManagementHeader_footerIndexRoute =
  AppManagementHeader_footerIndexRouteImport.update({
    id: '/header_footer/',
    path: '/header_footer/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/header_footer/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementDivisionsIndexRoute =
  AppManagementDivisionsIndexRouteImport.update({
    id: '/divisions/',
    path: '/divisions/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/divisions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementDivisionIndexRoute =
  AppManagementDivisionIndexRouteImport.update({
    id: '/division/',
    path: '/division/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/division/index.lazy').then((d) => d.Route),
  )
const AppManagementDistributionIndexRoute =
  AppManagementDistributionIndexRouteImport.update({
    id: '/distribution/',
    path: '/distribution/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/distribution/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementCorporationsIndexRoute =
  AppManagementCorporationsIndexRouteImport.update({
    id: '/corporations/',
    path: '/corporations/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/corporations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementAdvisersIndexRoute =
  AppManagementAdvisersIndexRouteImport.update({
    id: '/advisers/',
    path: '/advisers/',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/advisers/index.lazy').then((d) => d.Route),
  )
const AppManagementTemplatesGeneralRoute =
  AppManagementTemplatesGeneralRouteImport.update({
    id: '/templates/general',
    path: '/templates/general',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/templates/general.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementTemplatesDivisionsRoute =
  AppManagementTemplatesDivisionsRouteImport.update({
    id: '/templates/divisions',
    path: '/templates/divisions',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/templates/divisions.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementTemplatesDivisionRoute =
  AppManagementTemplatesDivisionRouteImport.update({
    id: '/templates/division',
    path: '/templates/division',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/templates/division.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementBucketConfigurationsRoute =
  AppManagementBucketConfigurationsRouteImport.update({
    id: '/bucket/configurations',
    path: '/bucket/configurations',
    getParentRoute: () => AppManagementRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/bucket/configurations.lazy').then(
      (d) => d.Route,
    ),
  )
const AppLeadsDetailsLeadIdRoute = AppLeadsDetailsLeadIdRouteImport.update({
  id: '/leads_/details/$leadId',
  path: '/leads/details/$leadId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/leads_/details/$leadId.lazy').then((d) => d.Route),
)
const AppLeadsDetailsLeadIdIndexRoute =
  AppLeadsDetailsLeadIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppManagementTemplatesGeneralTemplateIdRoute =
  AppManagementTemplatesGeneralTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AppManagementTemplatesGeneralRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/templates/general/$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementTemplatesDivisionsTemplateIdRoute =
  AppManagementTemplatesDivisionsTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AppManagementTemplatesDivisionsRoute,
  } as any).lazy(() =>
    import(
      './routes/_app/management/templates/divisions/$templateId.lazy'
    ).then((d) => d.Route),
  )
const AppManagementTemplatesDivisionTemplateIdRoute =
  AppManagementTemplatesDivisionTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AppManagementTemplatesDivisionRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/templates/division/$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppManagementBucketConfigurationsBucketRoute =
  AppManagementBucketConfigurationsBucketRouteImport.update({
    id: '/$bucket',
    path: '/$bucket',
    getParentRoute: () => AppManagementBucketConfigurationsRoute,
  } as any).lazy(() =>
    import('./routes/_app/management/bucket/configurations/$bucket.lazy').then(
      (d) => d.Route,
    ),
  )
const AppLeadsDetailsLeadIdOfferManagementRoute =
  AppLeadsDetailsLeadIdOfferManagementRouteImport.update({
    id: '/offer-management',
    path: '/offer-management',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppLeadsDetailsLeadIdIncomeProtectionRoute =
  AppLeadsDetailsLeadIdIncomeProtectionRouteImport.update({
    id: '/income-protection',
    path: '/income-protection',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppLeadsDetailsLeadIdHistoryRoute =
  AppLeadsDetailsLeadIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppLeadsDetailsLeadIdDocumentCenterRoute =
  AppLeadsDetailsLeadIdDocumentCenterRouteImport.update({
    id: '/document-center',
    path: '/document-center',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppLeadsDetailsLeadIdCustomerDataRoute =
  AppLeadsDetailsLeadIdCustomerDataRouteImport.update({
    id: '/customer-data',
    path: '/customer-data',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppLeadsDetailsLeadIdBankRequestRoute =
  AppLeadsDetailsLeadIdBankRequestRouteImport.update({
    id: '/bank-request',
    path: '/bank-request',
    getParentRoute: () => AppLeadsDetailsLeadIdRoute,
  } as any)
const AppLeadsDetailsLeadIdHistoryIndexRoute =
  AppLeadsDetailsLeadIdHistoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLeadsDetailsLeadIdHistoryRoute,
  } as any)
const AppLeadsDetailsLeadIdCustomerDataIndexRoute =
  AppLeadsDetailsLeadIdCustomerDataIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLeadsDetailsLeadIdCustomerDataRoute,
  } as any)
const AppLeadsDetailsLeadIdBankRequestIndexRoute =
  AppLeadsDetailsLeadIdBankRequestIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLeadsDetailsLeadIdBankRequestRoute,
  } as any)
const AppLeadsDetailsLeadIdHistoryCategoryIdRoute =
  AppLeadsDetailsLeadIdHistoryCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => AppLeadsDetailsLeadIdHistoryRoute,
  } as any).lazy(() =>
    import(
      './routes/_app/leads_/details/$leadId/history/$categoryId.lazy'
    ).then((d) => d.Route),
  )
const AppLeadsDetailsLeadIdCustomerDataCustomerTabRoute =
  AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteImport.update({
    id: '/$customerTab',
    path: '/$customerTab',
    getParentRoute: () => AppLeadsDetailsLeadIdCustomerDataRoute,
  } as any)
const AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute =
  AppLeadsDetailsLeadIdBankRequestRequestHistoryRouteImport.update({
    id: '/request-history',
    path: '/request-history',
    getParentRoute: () => AppLeadsDetailsLeadIdBankRequestRoute,
  } as any)
const AppLeadsDetailsLeadIdBankRequestNewRequestRoute =
  AppLeadsDetailsLeadIdBankRequestNewRequestRouteImport.update({
    id: '/new-request',
    path: '/new-request',
    getParentRoute: () => AppLeadsDetailsLeadIdBankRequestRoute,
  } as any)
const AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute =
  AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRouteImport.update(
    {
      id: '/$realEstateId/$step',
      path: '/$realEstateId/$step',
      getParentRoute: () => AppLeadsDetailsLeadIdCustomerDataCustomerTabRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/accounting': typeof AppAccountingRoute
  '/bucketLeads': typeof AppBucketLeadsRoute
  '/calendar': typeof AppCalendarRoute
  '/communication': typeof AppCommunicationRoute
  '/evaluation': typeof AppEvaluationRoute
  '/leads': typeof AppLeadsRoute
  '/mail': typeof AppMailRoute
  '/management': typeof AppManagementRouteWithChildren
  '/accessdenied': typeof AuthAccessdeniedRoute
  '/': typeof AppIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/management/': typeof AppManagementIndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/register': typeof AuthRegisterIndexRoute
  '/leads/details/$leadId': typeof AppLeadsDetailsLeadIdRouteWithChildren
  '/management/bucket/configurations': typeof AppManagementBucketConfigurationsRouteWithChildren
  '/management/templates/division': typeof AppManagementTemplatesDivisionRouteWithChildren
  '/management/templates/divisions': typeof AppManagementTemplatesDivisionsRouteWithChildren
  '/management/templates/general': typeof AppManagementTemplatesGeneralRouteWithChildren
  '/management/advisers': typeof AppManagementAdvisersIndexRoute
  '/management/corporations': typeof AppManagementCorporationsIndexRoute
  '/management/distribution': typeof AppManagementDistributionIndexRoute
  '/management/division': typeof AppManagementDivisionIndexRoute
  '/management/divisions': typeof AppManagementDivisionsIndexRoute
  '/management/header_footer': typeof AppManagementHeader_footerIndexRoute
  '/management/partners': typeof AppManagementPartnersIndexRoute
  '/management/users': typeof AppManagementUsersIndexRoute
  '/request/password': typeof AuthRequestPasswordIndexRoute
  '/reset/password': typeof AuthResetPasswordIndexRoute
  '/reset/secret': typeof AuthResetSecretIndexRoute
  '/leads/details/$leadId/bank-request': typeof AppLeadsDetailsLeadIdBankRequestRouteWithChildren
  '/leads/details/$leadId/customer-data': typeof AppLeadsDetailsLeadIdCustomerDataRouteWithChildren
  '/leads/details/$leadId/document-center': typeof AppLeadsDetailsLeadIdDocumentCenterRoute
  '/leads/details/$leadId/history': typeof AppLeadsDetailsLeadIdHistoryRouteWithChildren
  '/leads/details/$leadId/income-protection': typeof AppLeadsDetailsLeadIdIncomeProtectionRoute
  '/leads/details/$leadId/offer-management': typeof AppLeadsDetailsLeadIdOfferManagementRoute
  '/management/bucket/configurations/$bucket': typeof AppManagementBucketConfigurationsBucketRoute
  '/management/templates/division/$templateId': typeof AppManagementTemplatesDivisionTemplateIdRoute
  '/management/templates/divisions/$templateId': typeof AppManagementTemplatesDivisionsTemplateIdRoute
  '/management/templates/general/$templateId': typeof AppManagementTemplatesGeneralTemplateIdRoute
  '/leads/details/$leadId/': typeof AppLeadsDetailsLeadIdIndexRoute
  '/leads/details/$leadId/bank-request/new-request': typeof AppLeadsDetailsLeadIdBankRequestNewRequestRoute
  '/leads/details/$leadId/bank-request/request-history': typeof AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute
  '/leads/details/$leadId/customer-data/$customerTab': typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteWithChildren
  '/leads/details/$leadId/history/$categoryId': typeof AppLeadsDetailsLeadIdHistoryCategoryIdRoute
  '/leads/details/$leadId/bank-request/': typeof AppLeadsDetailsLeadIdBankRequestIndexRoute
  '/leads/details/$leadId/customer-data/': typeof AppLeadsDetailsLeadIdCustomerDataIndexRoute
  '/leads/details/$leadId/history/': typeof AppLeadsDetailsLeadIdHistoryIndexRoute
  '/leads/details/$leadId/customer-data/$customerTab/$realEstateId/$step': typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute
}
export interface FileRoutesByTo {
  '/accounting': typeof AppAccountingRoute
  '/bucketLeads': typeof AppBucketLeadsRoute
  '/calendar': typeof AppCalendarRoute
  '/communication': typeof AppCommunicationRoute
  '/evaluation': typeof AppEvaluationRoute
  '/leads': typeof AppLeadsRoute
  '/mail': typeof AppMailRoute
  '/accessdenied': typeof AuthAccessdeniedRoute
  '/': typeof AppIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/management': typeof AppManagementIndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/register': typeof AuthRegisterIndexRoute
  '/management/bucket/configurations': typeof AppManagementBucketConfigurationsRouteWithChildren
  '/management/templates/division': typeof AppManagementTemplatesDivisionRouteWithChildren
  '/management/templates/divisions': typeof AppManagementTemplatesDivisionsRouteWithChildren
  '/management/templates/general': typeof AppManagementTemplatesGeneralRouteWithChildren
  '/management/advisers': typeof AppManagementAdvisersIndexRoute
  '/management/corporations': typeof AppManagementCorporationsIndexRoute
  '/management/distribution': typeof AppManagementDistributionIndexRoute
  '/management/division': typeof AppManagementDivisionIndexRoute
  '/management/divisions': typeof AppManagementDivisionsIndexRoute
  '/management/header_footer': typeof AppManagementHeader_footerIndexRoute
  '/management/partners': typeof AppManagementPartnersIndexRoute
  '/management/users': typeof AppManagementUsersIndexRoute
  '/request/password': typeof AuthRequestPasswordIndexRoute
  '/reset/password': typeof AuthResetPasswordIndexRoute
  '/reset/secret': typeof AuthResetSecretIndexRoute
  '/leads/details/$leadId/document-center': typeof AppLeadsDetailsLeadIdDocumentCenterRoute
  '/leads/details/$leadId/income-protection': typeof AppLeadsDetailsLeadIdIncomeProtectionRoute
  '/leads/details/$leadId/offer-management': typeof AppLeadsDetailsLeadIdOfferManagementRoute
  '/management/bucket/configurations/$bucket': typeof AppManagementBucketConfigurationsBucketRoute
  '/management/templates/division/$templateId': typeof AppManagementTemplatesDivisionTemplateIdRoute
  '/management/templates/divisions/$templateId': typeof AppManagementTemplatesDivisionsTemplateIdRoute
  '/management/templates/general/$templateId': typeof AppManagementTemplatesGeneralTemplateIdRoute
  '/leads/details/$leadId': typeof AppLeadsDetailsLeadIdIndexRoute
  '/leads/details/$leadId/bank-request/new-request': typeof AppLeadsDetailsLeadIdBankRequestNewRequestRoute
  '/leads/details/$leadId/bank-request/request-history': typeof AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute
  '/leads/details/$leadId/customer-data/$customerTab': typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteWithChildren
  '/leads/details/$leadId/history/$categoryId': typeof AppLeadsDetailsLeadIdHistoryCategoryIdRoute
  '/leads/details/$leadId/bank-request': typeof AppLeadsDetailsLeadIdBankRequestIndexRoute
  '/leads/details/$leadId/customer-data': typeof AppLeadsDetailsLeadIdCustomerDataIndexRoute
  '/leads/details/$leadId/history': typeof AppLeadsDetailsLeadIdHistoryIndexRoute
  '/leads/details/$leadId/customer-data/$customerTab/$realEstateId/$step': typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/accounting': typeof AppAccountingRoute
  '/_app/bucketLeads': typeof AppBucketLeadsRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/communication': typeof AppCommunicationRoute
  '/_app/evaluation': typeof AppEvaluationRoute
  '/_app/leads': typeof AppLeadsRoute
  '/_app/mail': typeof AppMailRoute
  '/_app/management': typeof AppManagementRouteWithChildren
  '/_auth/accessdenied': typeof AuthAccessdeniedRoute
  '/_app/': typeof AppIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/management/': typeof AppManagementIndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_auth/register/': typeof AuthRegisterIndexRoute
  '/_app/leads_/details/$leadId': typeof AppLeadsDetailsLeadIdRouteWithChildren
  '/_app/management/bucket/configurations': typeof AppManagementBucketConfigurationsRouteWithChildren
  '/_app/management/templates/division': typeof AppManagementTemplatesDivisionRouteWithChildren
  '/_app/management/templates/divisions': typeof AppManagementTemplatesDivisionsRouteWithChildren
  '/_app/management/templates/general': typeof AppManagementTemplatesGeneralRouteWithChildren
  '/_app/management/advisers/': typeof AppManagementAdvisersIndexRoute
  '/_app/management/corporations/': typeof AppManagementCorporationsIndexRoute
  '/_app/management/distribution/': typeof AppManagementDistributionIndexRoute
  '/_app/management/division/': typeof AppManagementDivisionIndexRoute
  '/_app/management/divisions/': typeof AppManagementDivisionsIndexRoute
  '/_app/management/header_footer/': typeof AppManagementHeader_footerIndexRoute
  '/_app/management/partners/': typeof AppManagementPartnersIndexRoute
  '/_app/management/users/': typeof AppManagementUsersIndexRoute
  '/_auth/request/password/': typeof AuthRequestPasswordIndexRoute
  '/_auth/reset/password/': typeof AuthResetPasswordIndexRoute
  '/_auth/reset/secret/': typeof AuthResetSecretIndexRoute
  '/_app/leads_/details/$leadId/bank-request': typeof AppLeadsDetailsLeadIdBankRequestRouteWithChildren
  '/_app/leads_/details/$leadId/customer-data': typeof AppLeadsDetailsLeadIdCustomerDataRouteWithChildren
  '/_app/leads_/details/$leadId/document-center': typeof AppLeadsDetailsLeadIdDocumentCenterRoute
  '/_app/leads_/details/$leadId/history': typeof AppLeadsDetailsLeadIdHistoryRouteWithChildren
  '/_app/leads_/details/$leadId/income-protection': typeof AppLeadsDetailsLeadIdIncomeProtectionRoute
  '/_app/leads_/details/$leadId/offer-management': typeof AppLeadsDetailsLeadIdOfferManagementRoute
  '/_app/management/bucket/configurations/$bucket': typeof AppManagementBucketConfigurationsBucketRoute
  '/_app/management/templates/division/$templateId': typeof AppManagementTemplatesDivisionTemplateIdRoute
  '/_app/management/templates/divisions/$templateId': typeof AppManagementTemplatesDivisionsTemplateIdRoute
  '/_app/management/templates/general/$templateId': typeof AppManagementTemplatesGeneralTemplateIdRoute
  '/_app/leads_/details/$leadId/': typeof AppLeadsDetailsLeadIdIndexRoute
  '/_app/leads_/details/$leadId/bank-request/new-request': typeof AppLeadsDetailsLeadIdBankRequestNewRequestRoute
  '/_app/leads_/details/$leadId/bank-request/request-history': typeof AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute
  '/_app/leads_/details/$leadId/customer-data/$customerTab': typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteWithChildren
  '/_app/leads_/details/$leadId/history/$categoryId': typeof AppLeadsDetailsLeadIdHistoryCategoryIdRoute
  '/_app/leads_/details/$leadId/bank-request/': typeof AppLeadsDetailsLeadIdBankRequestIndexRoute
  '/_app/leads_/details/$leadId/customer-data/': typeof AppLeadsDetailsLeadIdCustomerDataIndexRoute
  '/_app/leads_/details/$leadId/history/': typeof AppLeadsDetailsLeadIdHistoryIndexRoute
  '/_app/leads_/details/$leadId/customer-data/$customerTab/$realEstateId/$step': typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/accounting'
    | '/bucketLeads'
    | '/calendar'
    | '/communication'
    | '/evaluation'
    | '/leads'
    | '/mail'
    | '/management'
    | '/accessdenied'
    | '/'
    | '/dashboard'
    | '/management/'
    | '/login'
    | '/register'
    | '/leads/details/$leadId'
    | '/management/bucket/configurations'
    | '/management/templates/division'
    | '/management/templates/divisions'
    | '/management/templates/general'
    | '/management/advisers'
    | '/management/corporations'
    | '/management/distribution'
    | '/management/division'
    | '/management/divisions'
    | '/management/header_footer'
    | '/management/partners'
    | '/management/users'
    | '/request/password'
    | '/reset/password'
    | '/reset/secret'
    | '/leads/details/$leadId/bank-request'
    | '/leads/details/$leadId/customer-data'
    | '/leads/details/$leadId/document-center'
    | '/leads/details/$leadId/history'
    | '/leads/details/$leadId/income-protection'
    | '/leads/details/$leadId/offer-management'
    | '/management/bucket/configurations/$bucket'
    | '/management/templates/division/$templateId'
    | '/management/templates/divisions/$templateId'
    | '/management/templates/general/$templateId'
    | '/leads/details/$leadId/'
    | '/leads/details/$leadId/bank-request/new-request'
    | '/leads/details/$leadId/bank-request/request-history'
    | '/leads/details/$leadId/customer-data/$customerTab'
    | '/leads/details/$leadId/history/$categoryId'
    | '/leads/details/$leadId/bank-request/'
    | '/leads/details/$leadId/customer-data/'
    | '/leads/details/$leadId/history/'
    | '/leads/details/$leadId/customer-data/$customerTab/$realEstateId/$step'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accounting'
    | '/bucketLeads'
    | '/calendar'
    | '/communication'
    | '/evaluation'
    | '/leads'
    | '/mail'
    | '/accessdenied'
    | '/'
    | '/dashboard'
    | '/management'
    | '/login'
    | '/register'
    | '/management/bucket/configurations'
    | '/management/templates/division'
    | '/management/templates/divisions'
    | '/management/templates/general'
    | '/management/advisers'
    | '/management/corporations'
    | '/management/distribution'
    | '/management/division'
    | '/management/divisions'
    | '/management/header_footer'
    | '/management/partners'
    | '/management/users'
    | '/request/password'
    | '/reset/password'
    | '/reset/secret'
    | '/leads/details/$leadId/document-center'
    | '/leads/details/$leadId/income-protection'
    | '/leads/details/$leadId/offer-management'
    | '/management/bucket/configurations/$bucket'
    | '/management/templates/division/$templateId'
    | '/management/templates/divisions/$templateId'
    | '/management/templates/general/$templateId'
    | '/leads/details/$leadId'
    | '/leads/details/$leadId/bank-request/new-request'
    | '/leads/details/$leadId/bank-request/request-history'
    | '/leads/details/$leadId/customer-data/$customerTab'
    | '/leads/details/$leadId/history/$categoryId'
    | '/leads/details/$leadId/bank-request'
    | '/leads/details/$leadId/customer-data'
    | '/leads/details/$leadId/history'
    | '/leads/details/$leadId/customer-data/$customerTab/$realEstateId/$step'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/accounting'
    | '/_app/bucketLeads'
    | '/_app/calendar'
    | '/_app/communication'
    | '/_app/evaluation'
    | '/_app/leads'
    | '/_app/mail'
    | '/_app/management'
    | '/_auth/accessdenied'
    | '/_app/'
    | '/_app/dashboard/'
    | '/_app/management/'
    | '/_auth/login/'
    | '/_auth/register/'
    | '/_app/leads_/details/$leadId'
    | '/_app/management/bucket/configurations'
    | '/_app/management/templates/division'
    | '/_app/management/templates/divisions'
    | '/_app/management/templates/general'
    | '/_app/management/advisers/'
    | '/_app/management/corporations/'
    | '/_app/management/distribution/'
    | '/_app/management/division/'
    | '/_app/management/divisions/'
    | '/_app/management/header_footer/'
    | '/_app/management/partners/'
    | '/_app/management/users/'
    | '/_auth/request/password/'
    | '/_auth/reset/password/'
    | '/_auth/reset/secret/'
    | '/_app/leads_/details/$leadId/bank-request'
    | '/_app/leads_/details/$leadId/customer-data'
    | '/_app/leads_/details/$leadId/document-center'
    | '/_app/leads_/details/$leadId/history'
    | '/_app/leads_/details/$leadId/income-protection'
    | '/_app/leads_/details/$leadId/offer-management'
    | '/_app/management/bucket/configurations/$bucket'
    | '/_app/management/templates/division/$templateId'
    | '/_app/management/templates/divisions/$templateId'
    | '/_app/management/templates/general/$templateId'
    | '/_app/leads_/details/$leadId/'
    | '/_app/leads_/details/$leadId/bank-request/new-request'
    | '/_app/leads_/details/$leadId/bank-request/request-history'
    | '/_app/leads_/details/$leadId/customer-data/$customerTab'
    | '/_app/leads_/details/$leadId/history/$categoryId'
    | '/_app/leads_/details/$leadId/bank-request/'
    | '/_app/leads_/details/$leadId/customer-data/'
    | '/_app/leads_/details/$leadId/history/'
    | '/_app/leads_/details/$leadId/customer-data/$customerTab/$realEstateId/$step'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/accessdenied': {
      id: '/_auth/accessdenied'
      path: '/accessdenied'
      fullPath: '/accessdenied'
      preLoaderRoute: typeof AuthAccessdeniedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/management': {
      id: '/_app/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof AppManagementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mail': {
      id: '/_app/mail'
      path: '/mail'
      fullPath: '/mail'
      preLoaderRoute: typeof AppMailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads': {
      id: '/_app/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AppLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/evaluation': {
      id: '/_app/evaluation'
      path: '/evaluation'
      fullPath: '/evaluation'
      preLoaderRoute: typeof AppEvaluationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/communication': {
      id: '/_app/communication'
      path: '/communication'
      fullPath: '/communication'
      preLoaderRoute: typeof AppCommunicationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bucketLeads': {
      id: '/_app/bucketLeads'
      path: '/bucketLeads'
      fullPath: '/bucketLeads'
      preLoaderRoute: typeof AppBucketLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting': {
      id: '/_app/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AppAccountingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/register/': {
      id: '/_auth/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/management/': {
      id: '/_app/management/'
      path: '/'
      fullPath: '/management/'
      preLoaderRoute: typeof AppManagementIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/reset/secret/': {
      id: '/_auth/reset/secret/'
      path: '/reset/secret'
      fullPath: '/reset/secret'
      preLoaderRoute: typeof AuthResetSecretIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset/password/': {
      id: '/_auth/reset/password/'
      path: '/reset/password'
      fullPath: '/reset/password'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/request/password/': {
      id: '/_auth/request/password/'
      path: '/request/password'
      fullPath: '/request/password'
      preLoaderRoute: typeof AuthRequestPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/management/users/': {
      id: '/_app/management/users/'
      path: '/users'
      fullPath: '/management/users'
      preLoaderRoute: typeof AppManagementUsersIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/partners/': {
      id: '/_app/management/partners/'
      path: '/partners'
      fullPath: '/management/partners'
      preLoaderRoute: typeof AppManagementPartnersIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/header_footer/': {
      id: '/_app/management/header_footer/'
      path: '/header_footer'
      fullPath: '/management/header_footer'
      preLoaderRoute: typeof AppManagementHeader_footerIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/divisions/': {
      id: '/_app/management/divisions/'
      path: '/divisions'
      fullPath: '/management/divisions'
      preLoaderRoute: typeof AppManagementDivisionsIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/division/': {
      id: '/_app/management/division/'
      path: '/division'
      fullPath: '/management/division'
      preLoaderRoute: typeof AppManagementDivisionIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/distribution/': {
      id: '/_app/management/distribution/'
      path: '/distribution'
      fullPath: '/management/distribution'
      preLoaderRoute: typeof AppManagementDistributionIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/corporations/': {
      id: '/_app/management/corporations/'
      path: '/corporations'
      fullPath: '/management/corporations'
      preLoaderRoute: typeof AppManagementCorporationsIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/advisers/': {
      id: '/_app/management/advisers/'
      path: '/advisers'
      fullPath: '/management/advisers'
      preLoaderRoute: typeof AppManagementAdvisersIndexRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/templates/general': {
      id: '/_app/management/templates/general'
      path: '/templates/general'
      fullPath: '/management/templates/general'
      preLoaderRoute: typeof AppManagementTemplatesGeneralRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/templates/divisions': {
      id: '/_app/management/templates/divisions'
      path: '/templates/divisions'
      fullPath: '/management/templates/divisions'
      preLoaderRoute: typeof AppManagementTemplatesDivisionsRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/templates/division': {
      id: '/_app/management/templates/division'
      path: '/templates/division'
      fullPath: '/management/templates/division'
      preLoaderRoute: typeof AppManagementTemplatesDivisionRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/management/bucket/configurations': {
      id: '/_app/management/bucket/configurations'
      path: '/bucket/configurations'
      fullPath: '/management/bucket/configurations'
      preLoaderRoute: typeof AppManagementBucketConfigurationsRouteImport
      parentRoute: typeof AppManagementRoute
    }
    '/_app/leads_/details/$leadId': {
      id: '/_app/leads_/details/$leadId'
      path: '/leads/details/$leadId'
      fullPath: '/leads/details/$leadId'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads_/details/$leadId/': {
      id: '/_app/leads_/details/$leadId/'
      path: '/'
      fullPath: '/leads/details/$leadId/'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdIndexRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/management/templates/general/$templateId': {
      id: '/_app/management/templates/general/$templateId'
      path: '/$templateId'
      fullPath: '/management/templates/general/$templateId'
      preLoaderRoute: typeof AppManagementTemplatesGeneralTemplateIdRouteImport
      parentRoute: typeof AppManagementTemplatesGeneralRoute
    }
    '/_app/management/templates/divisions/$templateId': {
      id: '/_app/management/templates/divisions/$templateId'
      path: '/$templateId'
      fullPath: '/management/templates/divisions/$templateId'
      preLoaderRoute: typeof AppManagementTemplatesDivisionsTemplateIdRouteImport
      parentRoute: typeof AppManagementTemplatesDivisionsRoute
    }
    '/_app/management/templates/division/$templateId': {
      id: '/_app/management/templates/division/$templateId'
      path: '/$templateId'
      fullPath: '/management/templates/division/$templateId'
      preLoaderRoute: typeof AppManagementTemplatesDivisionTemplateIdRouteImport
      parentRoute: typeof AppManagementTemplatesDivisionRoute
    }
    '/_app/management/bucket/configurations/$bucket': {
      id: '/_app/management/bucket/configurations/$bucket'
      path: '/$bucket'
      fullPath: '/management/bucket/configurations/$bucket'
      preLoaderRoute: typeof AppManagementBucketConfigurationsBucketRouteImport
      parentRoute: typeof AppManagementBucketConfigurationsRoute
    }
    '/_app/leads_/details/$leadId/offer-management': {
      id: '/_app/leads_/details/$leadId/offer-management'
      path: '/offer-management'
      fullPath: '/leads/details/$leadId/offer-management'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdOfferManagementRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/leads_/details/$leadId/income-protection': {
      id: '/_app/leads_/details/$leadId/income-protection'
      path: '/income-protection'
      fullPath: '/leads/details/$leadId/income-protection'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdIncomeProtectionRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/leads_/details/$leadId/history': {
      id: '/_app/leads_/details/$leadId/history'
      path: '/history'
      fullPath: '/leads/details/$leadId/history'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdHistoryRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/leads_/details/$leadId/document-center': {
      id: '/_app/leads_/details/$leadId/document-center'
      path: '/document-center'
      fullPath: '/leads/details/$leadId/document-center'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdDocumentCenterRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/leads_/details/$leadId/customer-data': {
      id: '/_app/leads_/details/$leadId/customer-data'
      path: '/customer-data'
      fullPath: '/leads/details/$leadId/customer-data'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdCustomerDataRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/leads_/details/$leadId/bank-request': {
      id: '/_app/leads_/details/$leadId/bank-request'
      path: '/bank-request'
      fullPath: '/leads/details/$leadId/bank-request'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdBankRequestRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdRoute
    }
    '/_app/leads_/details/$leadId/history/': {
      id: '/_app/leads_/details/$leadId/history/'
      path: '/'
      fullPath: '/leads/details/$leadId/history/'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdHistoryIndexRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdHistoryRoute
    }
    '/_app/leads_/details/$leadId/customer-data/': {
      id: '/_app/leads_/details/$leadId/customer-data/'
      path: '/'
      fullPath: '/leads/details/$leadId/customer-data/'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdCustomerDataIndexRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdCustomerDataRoute
    }
    '/_app/leads_/details/$leadId/bank-request/': {
      id: '/_app/leads_/details/$leadId/bank-request/'
      path: '/'
      fullPath: '/leads/details/$leadId/bank-request/'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdBankRequestIndexRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdBankRequestRoute
    }
    '/_app/leads_/details/$leadId/history/$categoryId': {
      id: '/_app/leads_/details/$leadId/history/$categoryId'
      path: '/$categoryId'
      fullPath: '/leads/details/$leadId/history/$categoryId'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdHistoryCategoryIdRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdHistoryRoute
    }
    '/_app/leads_/details/$leadId/customer-data/$customerTab': {
      id: '/_app/leads_/details/$leadId/customer-data/$customerTab'
      path: '/$customerTab'
      fullPath: '/leads/details/$leadId/customer-data/$customerTab'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdCustomerDataRoute
    }
    '/_app/leads_/details/$leadId/bank-request/request-history': {
      id: '/_app/leads_/details/$leadId/bank-request/request-history'
      path: '/request-history'
      fullPath: '/leads/details/$leadId/bank-request/request-history'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdBankRequestRequestHistoryRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdBankRequestRoute
    }
    '/_app/leads_/details/$leadId/bank-request/new-request': {
      id: '/_app/leads_/details/$leadId/bank-request/new-request'
      path: '/new-request'
      fullPath: '/leads/details/$leadId/bank-request/new-request'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdBankRequestNewRequestRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdBankRequestRoute
    }
    '/_app/leads_/details/$leadId/customer-data/$customerTab/$realEstateId/$step': {
      id: '/_app/leads_/details/$leadId/customer-data/$customerTab/$realEstateId/$step'
      path: '/$realEstateId/$step'
      fullPath: '/leads/details/$leadId/customer-data/$customerTab/$realEstateId/$step'
      preLoaderRoute: typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRouteImport
      parentRoute: typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRoute
    }
  }
}

interface AppManagementBucketConfigurationsRouteChildren {
  AppManagementBucketConfigurationsBucketRoute: typeof AppManagementBucketConfigurationsBucketRoute
}

const AppManagementBucketConfigurationsRouteChildren: AppManagementBucketConfigurationsRouteChildren =
  {
    AppManagementBucketConfigurationsBucketRoute:
      AppManagementBucketConfigurationsBucketRoute,
  }

const AppManagementBucketConfigurationsRouteWithChildren =
  AppManagementBucketConfigurationsRoute._addFileChildren(
    AppManagementBucketConfigurationsRouteChildren,
  )

interface AppManagementTemplatesDivisionRouteChildren {
  AppManagementTemplatesDivisionTemplateIdRoute: typeof AppManagementTemplatesDivisionTemplateIdRoute
}

const AppManagementTemplatesDivisionRouteChildren: AppManagementTemplatesDivisionRouteChildren =
  {
    AppManagementTemplatesDivisionTemplateIdRoute:
      AppManagementTemplatesDivisionTemplateIdRoute,
  }

const AppManagementTemplatesDivisionRouteWithChildren =
  AppManagementTemplatesDivisionRoute._addFileChildren(
    AppManagementTemplatesDivisionRouteChildren,
  )

interface AppManagementTemplatesDivisionsRouteChildren {
  AppManagementTemplatesDivisionsTemplateIdRoute: typeof AppManagementTemplatesDivisionsTemplateIdRoute
}

const AppManagementTemplatesDivisionsRouteChildren: AppManagementTemplatesDivisionsRouteChildren =
  {
    AppManagementTemplatesDivisionsTemplateIdRoute:
      AppManagementTemplatesDivisionsTemplateIdRoute,
  }

const AppManagementTemplatesDivisionsRouteWithChildren =
  AppManagementTemplatesDivisionsRoute._addFileChildren(
    AppManagementTemplatesDivisionsRouteChildren,
  )

interface AppManagementTemplatesGeneralRouteChildren {
  AppManagementTemplatesGeneralTemplateIdRoute: typeof AppManagementTemplatesGeneralTemplateIdRoute
}

const AppManagementTemplatesGeneralRouteChildren: AppManagementTemplatesGeneralRouteChildren =
  {
    AppManagementTemplatesGeneralTemplateIdRoute:
      AppManagementTemplatesGeneralTemplateIdRoute,
  }

const AppManagementTemplatesGeneralRouteWithChildren =
  AppManagementTemplatesGeneralRoute._addFileChildren(
    AppManagementTemplatesGeneralRouteChildren,
  )

interface AppManagementRouteChildren {
  AppManagementIndexRoute: typeof AppManagementIndexRoute
  AppManagementBucketConfigurationsRoute: typeof AppManagementBucketConfigurationsRouteWithChildren
  AppManagementTemplatesDivisionRoute: typeof AppManagementTemplatesDivisionRouteWithChildren
  AppManagementTemplatesDivisionsRoute: typeof AppManagementTemplatesDivisionsRouteWithChildren
  AppManagementTemplatesGeneralRoute: typeof AppManagementTemplatesGeneralRouteWithChildren
  AppManagementAdvisersIndexRoute: typeof AppManagementAdvisersIndexRoute
  AppManagementCorporationsIndexRoute: typeof AppManagementCorporationsIndexRoute
  AppManagementDistributionIndexRoute: typeof AppManagementDistributionIndexRoute
  AppManagementDivisionIndexRoute: typeof AppManagementDivisionIndexRoute
  AppManagementDivisionsIndexRoute: typeof AppManagementDivisionsIndexRoute
  AppManagementHeader_footerIndexRoute: typeof AppManagementHeader_footerIndexRoute
  AppManagementPartnersIndexRoute: typeof AppManagementPartnersIndexRoute
  AppManagementUsersIndexRoute: typeof AppManagementUsersIndexRoute
}

const AppManagementRouteChildren: AppManagementRouteChildren = {
  AppManagementIndexRoute: AppManagementIndexRoute,
  AppManagementBucketConfigurationsRoute:
    AppManagementBucketConfigurationsRouteWithChildren,
  AppManagementTemplatesDivisionRoute:
    AppManagementTemplatesDivisionRouteWithChildren,
  AppManagementTemplatesDivisionsRoute:
    AppManagementTemplatesDivisionsRouteWithChildren,
  AppManagementTemplatesGeneralRoute:
    AppManagementTemplatesGeneralRouteWithChildren,
  AppManagementAdvisersIndexRoute: AppManagementAdvisersIndexRoute,
  AppManagementCorporationsIndexRoute: AppManagementCorporationsIndexRoute,
  AppManagementDistributionIndexRoute: AppManagementDistributionIndexRoute,
  AppManagementDivisionIndexRoute: AppManagementDivisionIndexRoute,
  AppManagementDivisionsIndexRoute: AppManagementDivisionsIndexRoute,
  AppManagementHeader_footerIndexRoute: AppManagementHeader_footerIndexRoute,
  AppManagementPartnersIndexRoute: AppManagementPartnersIndexRoute,
  AppManagementUsersIndexRoute: AppManagementUsersIndexRoute,
}

const AppManagementRouteWithChildren = AppManagementRoute._addFileChildren(
  AppManagementRouteChildren,
)

interface AppLeadsDetailsLeadIdBankRequestRouteChildren {
  AppLeadsDetailsLeadIdBankRequestNewRequestRoute: typeof AppLeadsDetailsLeadIdBankRequestNewRequestRoute
  AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute: typeof AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute
  AppLeadsDetailsLeadIdBankRequestIndexRoute: typeof AppLeadsDetailsLeadIdBankRequestIndexRoute
}

const AppLeadsDetailsLeadIdBankRequestRouteChildren: AppLeadsDetailsLeadIdBankRequestRouteChildren =
  {
    AppLeadsDetailsLeadIdBankRequestNewRequestRoute:
      AppLeadsDetailsLeadIdBankRequestNewRequestRoute,
    AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute:
      AppLeadsDetailsLeadIdBankRequestRequestHistoryRoute,
    AppLeadsDetailsLeadIdBankRequestIndexRoute:
      AppLeadsDetailsLeadIdBankRequestIndexRoute,
  }

const AppLeadsDetailsLeadIdBankRequestRouteWithChildren =
  AppLeadsDetailsLeadIdBankRequestRoute._addFileChildren(
    AppLeadsDetailsLeadIdBankRequestRouteChildren,
  )

interface AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteChildren {
  AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute: typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute
}

const AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteChildren: AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteChildren =
  {
    AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute:
      AppLeadsDetailsLeadIdCustomerDataCustomerTabRealEstateIdStepRoute,
  }

const AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteWithChildren =
  AppLeadsDetailsLeadIdCustomerDataCustomerTabRoute._addFileChildren(
    AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteChildren,
  )

interface AppLeadsDetailsLeadIdCustomerDataRouteChildren {
  AppLeadsDetailsLeadIdCustomerDataCustomerTabRoute: typeof AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteWithChildren
  AppLeadsDetailsLeadIdCustomerDataIndexRoute: typeof AppLeadsDetailsLeadIdCustomerDataIndexRoute
}

const AppLeadsDetailsLeadIdCustomerDataRouteChildren: AppLeadsDetailsLeadIdCustomerDataRouteChildren =
  {
    AppLeadsDetailsLeadIdCustomerDataCustomerTabRoute:
      AppLeadsDetailsLeadIdCustomerDataCustomerTabRouteWithChildren,
    AppLeadsDetailsLeadIdCustomerDataIndexRoute:
      AppLeadsDetailsLeadIdCustomerDataIndexRoute,
  }

const AppLeadsDetailsLeadIdCustomerDataRouteWithChildren =
  AppLeadsDetailsLeadIdCustomerDataRoute._addFileChildren(
    AppLeadsDetailsLeadIdCustomerDataRouteChildren,
  )

interface AppLeadsDetailsLeadIdHistoryRouteChildren {
  AppLeadsDetailsLeadIdHistoryCategoryIdRoute: typeof AppLeadsDetailsLeadIdHistoryCategoryIdRoute
  AppLeadsDetailsLeadIdHistoryIndexRoute: typeof AppLeadsDetailsLeadIdHistoryIndexRoute
}

const AppLeadsDetailsLeadIdHistoryRouteChildren: AppLeadsDetailsLeadIdHistoryRouteChildren =
  {
    AppLeadsDetailsLeadIdHistoryCategoryIdRoute:
      AppLeadsDetailsLeadIdHistoryCategoryIdRoute,
    AppLeadsDetailsLeadIdHistoryIndexRoute:
      AppLeadsDetailsLeadIdHistoryIndexRoute,
  }

const AppLeadsDetailsLeadIdHistoryRouteWithChildren =
  AppLeadsDetailsLeadIdHistoryRoute._addFileChildren(
    AppLeadsDetailsLeadIdHistoryRouteChildren,
  )

interface AppLeadsDetailsLeadIdRouteChildren {
  AppLeadsDetailsLeadIdBankRequestRoute: typeof AppLeadsDetailsLeadIdBankRequestRouteWithChildren
  AppLeadsDetailsLeadIdCustomerDataRoute: typeof AppLeadsDetailsLeadIdCustomerDataRouteWithChildren
  AppLeadsDetailsLeadIdDocumentCenterRoute: typeof AppLeadsDetailsLeadIdDocumentCenterRoute
  AppLeadsDetailsLeadIdHistoryRoute: typeof AppLeadsDetailsLeadIdHistoryRouteWithChildren
  AppLeadsDetailsLeadIdIncomeProtectionRoute: typeof AppLeadsDetailsLeadIdIncomeProtectionRoute
  AppLeadsDetailsLeadIdOfferManagementRoute: typeof AppLeadsDetailsLeadIdOfferManagementRoute
  AppLeadsDetailsLeadIdIndexRoute: typeof AppLeadsDetailsLeadIdIndexRoute
}

const AppLeadsDetailsLeadIdRouteChildren: AppLeadsDetailsLeadIdRouteChildren = {
  AppLeadsDetailsLeadIdBankRequestRoute:
    AppLeadsDetailsLeadIdBankRequestRouteWithChildren,
  AppLeadsDetailsLeadIdCustomerDataRoute:
    AppLeadsDetailsLeadIdCustomerDataRouteWithChildren,
  AppLeadsDetailsLeadIdDocumentCenterRoute:
    AppLeadsDetailsLeadIdDocumentCenterRoute,
  AppLeadsDetailsLeadIdHistoryRoute:
    AppLeadsDetailsLeadIdHistoryRouteWithChildren,
  AppLeadsDetailsLeadIdIncomeProtectionRoute:
    AppLeadsDetailsLeadIdIncomeProtectionRoute,
  AppLeadsDetailsLeadIdOfferManagementRoute:
    AppLeadsDetailsLeadIdOfferManagementRoute,
  AppLeadsDetailsLeadIdIndexRoute: AppLeadsDetailsLeadIdIndexRoute,
}

const AppLeadsDetailsLeadIdRouteWithChildren =
  AppLeadsDetailsLeadIdRoute._addFileChildren(
    AppLeadsDetailsLeadIdRouteChildren,
  )

interface AppRouteChildren {
  AppAccountingRoute: typeof AppAccountingRoute
  AppBucketLeadsRoute: typeof AppBucketLeadsRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppCommunicationRoute: typeof AppCommunicationRoute
  AppEvaluationRoute: typeof AppEvaluationRoute
  AppLeadsRoute: typeof AppLeadsRoute
  AppMailRoute: typeof AppMailRoute
  AppManagementRoute: typeof AppManagementRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppLeadsDetailsLeadIdRoute: typeof AppLeadsDetailsLeadIdRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountingRoute: AppAccountingRoute,
  AppBucketLeadsRoute: AppBucketLeadsRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppCommunicationRoute: AppCommunicationRoute,
  AppEvaluationRoute: AppEvaluationRoute,
  AppLeadsRoute: AppLeadsRoute,
  AppMailRoute: AppMailRoute,
  AppManagementRoute: AppManagementRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppLeadsDetailsLeadIdRoute: AppLeadsDetailsLeadIdRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAccessdeniedRoute: typeof AuthAccessdeniedRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthRegisterIndexRoute: typeof AuthRegisterIndexRoute
  AuthRequestPasswordIndexRoute: typeof AuthRequestPasswordIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthResetSecretIndexRoute: typeof AuthResetSecretIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccessdeniedRoute: AuthAccessdeniedRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthRegisterIndexRoute: AuthRegisterIndexRoute,
  AuthRequestPasswordIndexRoute: AuthRequestPasswordIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthResetSecretIndexRoute: AuthResetSecretIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
